import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';

import { useSubmitSaveSearch } from '@/hooks/useSubmitSaveSearch';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { deleteSavedSearch } from '@/redux/modules/search/save/saveSearch.actions';
import { createSaveSearchKeyBySearchParams } from '@/redux/modules/search/save/saveSearch.helpers';
import { getIsSavedSearch } from '@/redux/modules/search/save/saveSearch.selectors';
import { GlobalState } from '@/redux/store';
import { SearchParams as SearchParamsType } from '@/types/SaveSearch';

import SaveSearch from './SaveSearch';

type Props = {
    allSearchParams?: SearchParamsType;
    className?: string;
    saveSearchParams: SearchParamsType;
    small?: boolean;
    tooltipPlacement?: React.ComponentProps<typeof SaveSearch>['tooltipPlacement'];
};

const SaveSearchContainer = ({ allSearchParams, className, saveSearchParams, small, tooltipPlacement }: Props) => {
    const dispatch = useAppDispatch();
    const submitSaveSearch = useSubmitSaveSearch();

    const savedSearchKey = createSaveSearchKeyBySearchParams(saveSearchParams);
    const isSavedSearch = useAppSelector((state: GlobalState) => getIsSavedSearch(state, savedSearchKey));

    const submitSaveSearchLocal = React.useCallback(() => {
        submitSaveSearch(saveSearchParams, true);
    }, [saveSearchParams, submitSaveSearch]);

    const deleteSavedSearchLocal = React.useCallback(() => {
        if (isSavedSearch) {
            dispatch(deleteSavedSearch({ saveSearchParams }));
        }
    }, [dispatch, isSavedSearch, saveSearchParams]);

    return (
        <SaveSearch
            allSearchParams={allSearchParams}
            className={className}
            deleteSavedSearch={deleteSavedSearchLocal}
            isSavedSearch={isSavedSearch}
            small={small}
            submitSaveSearch={submitSaveSearchLocal}
            tooltipMessage={
                <FormattedMessage
                    id="follow_search_tooltip"
                    values={{
                        br1: <br key="follow-search-tooltip-br-1" />,
                        br2: <br key="follow-search-tooltip-br-2" />,
                    }}
                />
            }
            tooltipPlacement={tooltipPlacement}
        />
    );
};

export default SaveSearchContainer;
